import { useMiddlewareAuth } from '@composables/middleware/authenticated.hook'
import { useMiddlewareProfile } from '@composables/middleware/profile.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const authResult = await useMiddlewareAuth(to)
  if (authResult) return authResult

  await useMiddlewareProfile()
})
